<template>
  <BContentBox>
    <template #content>
      <div class="content">
        <div class="pb-200">
          <h3>{{ $t(`corpSettingApi.salesforce.subTabs.relationMap`) }}</h3>
        </div>
        <div class="pb-100">
          <div class="header-text">
            {{ $t("salesforceSettings.syncObjectType.objectMappingDesc") }}
          </div>
        </div>
        <div class="pb-100">
          <span class="header-text">{{ $t("sfObjectMappings.targetObjectLabel") }}</span>
        </div>
        <div class="hr" />
        <div
          v-loading="salesforceSettingLoading"
        >
          <div
            v-for="(mappingKey, index) in sfObjectMappingsKeys"
            :key="index"
            class="py-300 select-object"
            @click="() => selectObject(mappingKey)"
          >
            <span class="mapping-key-text">{{ $t(`sfObjectMappings.${mappingKey}`) }}</span>
          </div>
        </div>
        <div class="hr" />
      </div>
    </template>
  </BContentBox>
</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue';
import { SfObjectMappingService } from '@/api/user/resources/salesforce/sf_object_mapping';
import { useAvailableFeatureCheck } from '@/composable/available-feature-check';

const emit = defineEmits(['selectObject']);
const apiService = new SfObjectMappingService();
const salesforceSettingLoading = ref(true);
const sfObjectMappingsKeys = ref([]);
const selectObject = (object: string) => {
  emit('selectObject', object);
};
const { isSfDevelopment, isJinjer } = useAvailableFeatureCheck();

onMounted(async () => {
  const result = await apiService.getSfObjectMappingsKeys();
  // sfObjectMappingsKeys.value = result.data.sfObjectMappingsKeys;
  // TODO: リリース可能になったらこの処理が不要
  const mappingsKeys = result.data.sfObjectMappingsKeys;
  sfObjectMappingsKeys.value = mappingsKeys.filter((key) => key !== 'opportunity' || isSfDevelopment.value);
  salesforceSettingLoading.value = false;
});
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
}

.header-text {
  color: $textcolor-light;
  white-space: pre-wrap;
}

.mapping-key-text {
  font-weight: bold;
}

.select-object {
  cursor: pointer;

  &:first-child {
    margin-top: -8px;
  }
  &:not(:last-child) {
    border-bottom: 1px solid $bdcolor-base;
  }
}

.hr {
  border-bottom: 1px solid $bdcolor-base;
  margin-bottom: 8px;
}
</style>
